import { Box } from '@mui/material'
import MainLayout from '../../components/MainLayout'
import ForgotPasswordWizzard from '../../components/wizards/ForgotPasswordWizzard'

const ForgotPasswordPage: React.FC = () => {
  return (
    <MainLayout className={'t-login-view'}>
      <Box sx={{ maxWidth: '442px', width: '100%' }}>
        <ForgotPasswordWizzard />
      </Box>
    </MainLayout>
  )
}

export default ForgotPasswordPage
